import eventBus from '~/events/eventBus'
import eventDefinitions from '~/events/eventDefinitions'

eventBus.$on(eventDefinitions.NEWSLETTER.SUBSCRIBED, () => {
  window.dataLayer.push({
    event: eventDefinitions.NEWSLETTER.SUBSCRIBED,
  })
})
